import React from 'react';
import { motion } from 'framer-motion';
import { MapIcon, CoinsIcon, BriefcaseIcon, LineChartIcon } from 'lucide-react';
const services = [{
  icon: MapIcon,
  title: 'Channel Audits & Growth Maps',
  description: 'Deep analysis of your content, metadata, and algorithm positioning. Custom 90-day growth roadmap.'
}, {
  icon: CoinsIcon,
  title: 'Revenue Architecture',
  description: 'Multi-stream income design: subscriptions, tips, merch, sponsorships, and platform incentives optimized together.'
}, {
  icon: BriefcaseIcon,
  title: 'Brand Partnership Brokering',
  description: 'We negotiate and close brand deals at 2-5x what creators typically accept. Full rate card development.'
}, {
  icon: LineChartIcon,
  title: 'Audience Intelligence',
  description: 'Real-time analytics dashboards, sentiment tracking, and community health scoring to retain and grow your base.'
}];
export function Services() {
  return <section id="services" className="py-24 relative z-10 bg-studio-950" data-id="element-144">
      <div className="absolute inset-0 bg-grid opacity-30" data-id="element-145" />

      <div className="max-w-7xl mx-auto px-6 relative" data-id="element-146">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-16" data-id="element-147">
          <div className="flex items-center gap-4 mb-4" data-id="element-148">
            <div className="h-[1px] w-12 bg-stream-500" data-id="element-149" />
            <h2 className="text-3xl md:text-4xl font-bold" data-id="element-150">
              Our Broadcast Toolkit
            </h2>
          </div>
          <p className="text-gray-400 max-w-2xl text-lg" data-id="element-151">
            Everything you need to scale your viewership and multiply your
            revenue streams, engineered for modern creators.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-152">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="relative group h-full" data-id="element-153">
              <div className="absolute inset-0 bg-gradient-to-b from-stream-500/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity rounded-xl" data-id="element-154" />
              <div className="glass-panel p-8 rounded-xl border-t-2 border-t-transparent group-hover:border-t-stream-500 transition-all h-full flex flex-col" data-id="element-155">
                <service.icon className="w-8 h-8 text-stream-400 mb-6" data-id="element-156" />
                <h3 className="text-lg font-semibold text-white mb-4" data-id="element-157">
                  {service.title}
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed flex-grow" data-id="element-158">
                  {service.description}
                </p>

                <div className="mt-8 pt-4 border-t border-white/5 flex items-center justify-between" data-id="element-159">
                  <span className="font-mono text-xs text-stream-500" data-id="element-160">
                    MOD_{index + 1}
                  </span>
                  <div className="w-1.5 h-1.5 rounded-full bg-stream-500/50 group-hover:bg-stream-400 group-hover:shadow-[0_0_8px_rgba(168,85,247,0.8)] transition-all" data-id="element-161" />
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}